export default {
  qnaList: [],
  qnaDetail: {},
  srchParam: {},
  userInfo: {},
  errors: {},
  qnaReplyList: [], //* 이용문의 댓글 리스트
  qnaExcelData: [], //* 이용문의 내역 엑셀 다운로드 데이터
};
